<template>
  <div>
    <b-row>
      <b-col>
        <label class="mb-2">
          <i class="fa fa-fw fa-video text-muted"></i>
          {{ trans('attach_video_url') }}
          <small class="text-muted">
            <i class="fa fa-fw fa-info-circle" id="video_url"></i>
          </small>
          <b-tooltip target="video_url" triggers="hover">
            {{ trans('attach_video_url_details') }}
          </b-tooltip>
        </label>
      </b-col>
      <b-col class="col-auto">
        <a href="#" class="text-danger" @click.prevent="$emit('close')">
          <i class="fa fa-fw fa-times"></i>
        </a>
      </b-col>
    </b-row>

    <b-row v-if="!gated_vimeo_url">
      <b-col>
        <b-form-group>
          <b-form-input v-model="video_url" placeholder="https://youtu.be/xxxx ~ https://vimeo.com/xxxx"
                        @input="onChangeVideoUrl"/>
          <small v-if="!isVideoUrlValid" class="form-text text-danger text-right">
            {{ trans('invalid_url') }}
          </small>
          <small v-if="not_found" class="form-text text-danger text-right">
            {{ trans('video_not_found') }}
          </small>
          <small v-if="gated" class="form-text text-danger">
            {{ trans('video_gated') }}
          </small>
        </b-form-group>
      </b-col>
      <b-col class="col-auto pl-0">
        <b-button variant="primary" v-b-modal.choose-video>
          {{ trans('media') }}
        </b-button>
      </b-col>
    </b-row>

    <b-row v-if="gated_vimeo_url">
      <b-col>
        <b-form-group>
          <b-form-input :value="gated_vimeo_url.url" readonly/>
        </b-form-group>
      </b-col>
    </b-row>

    <b-modal
      id="choose-video"
      :title="trans('choose_video')"
      hide-footer
    >
      <b-tabs>
        <b-tab :title="trans('your_videos')" lazy>
          <videos-table
            video-name-only
            no-open
            :rows="5"
            :organization="organization"
            class="mt-2"
            @choose="onChooseFromVideosTable"
          ></videos-table>
        </b-tab>
        <b-tab v-if="organization.youtube_handle" title="Youtube" lazy>
          <third-party-videos-table
            type="youtube"
            video-name-only
            no-open
            hide-upload
            :rows="5"
            :organization="organization"
            class="mt-2"
            @choose="onChooseFromVideosTable"
          ></third-party-videos-table>
        </b-tab>
        <b-tab v-if="organization.vimeo_user_id" title="Vimeo" lazy>
          <third-party-videos-table
            type="vimeo"
            video-name-only
            no-open
            :rows="5"
            :organization="organization"
            class="mt-2"
            @choose="onChooseFromVideosTable"
          ></third-party-videos-table>
        </b-tab>
      </b-tabs>
    </b-modal>

  </div>
</template>

<script>
import VideosTable from './../media/VideosTable'
import ThirdPartyVideosTable from './../media/ThirdPartyVideosTable'

export default {
  components: {
    VideosTable,
    ThirdPartyVideosTable,
  },
  props: {
    organization: Object,
    gated_vimeo_url: Object,
    gated: Boolean,
    value: String, // v-model
  },
  data() {
    return {
      trans: trans,
      video_url: this.value,
      thumbnail_url: null,
      not_found: false,
    }
  },
  computed: {
    isVideoUrlValid() {
      if (!_.validateUrl((this.video_url || '').trim())) return false
      return this.isShortVideoUrl() || this.getYouTubeVideoId() || this.getVimeoVideoId()
    },
  },
  methods: {
    isShortVideoUrl() {
      return (this.video_url || '').indexOf('https://am.lol') === 0
    },
    getYouTubeVideoId() {
      return _.getYouTubeVideoId(this.video_url)
    },
    getVimeoVideoId() {
      return _.getVimeoVideoId(this.video_url)
    },
    onChooseFromVideosTable(video) {
      this.video_url = video.url
      this.$bvModal.hide('choose-video')
      this.onChangeVideoUrl(video)
      this.$emit('name', video.name)
    },
    onChangeVideoUrl(video) {
      const video_url = this.video_url != null ? this.video_url.trim() : null
      this.thumbnail_url = null
      this.not_found = false

      if (video && video.url && video.thumb_url) {
        this.video_url = video.short_url
        this.$emit('input', this.video_url)
        this.thumbnail_url = video.thumb_url
        this.$emit('thumbnail', this.thumbnail_url)
        this.$emit('gated', false)
        return
      }

      const youTubeId = this.getYouTubeVideoId()
      if (youTubeId) {
        this.$emit('input', video_url)
        this.thumbnail_url = `https://img.youtube.com/vi/${youTubeId}/hqdefault.jpg`
        this.$emit('thumbnail', this.thumbnail_url)
        this.$emit('gated', false)
        return
      }

      const vimeoId = this.getVimeoVideoId()
      if (vimeoId) {
        this.$emit('input', video_url)
        this.$emit('busy', true)
        let url = `/organization/${this.organization.id}/media/vimeo/${encodeURIComponent(vimeoId)}`
        axios.get(url)
          .then(response => {
            this.$emit('busy', false)
            this.thumbnail_url = response.data.thumbnail_url
            this.$emit('thumbnail', this.thumbnail_url)
            this.$emit('gated', response.data.am_gated)
          })
          .catch(error => {
            // Not found because bad URL or the video is private
            this.not_found = true
            this.$emit('busy', false)
            this.thumbnail_url = 'https://activitymessenger-assets-ca.s3.amazonaws.com/help/vimeo-placeholder.png'
            this.$emit('thumbnail', this.thumbnail_url)
          })
        return
      }

      this.$emit('input', null)
      this.$emit('thumbnail', this.thumbnail_url)
      this.$emit('gated', false)
    },
  },
  mounted() {
    window.sendOutVideoComponent = this
    //this.onChangeVideoUrl()
  },
}
</script>
